module.exports = __webpack_public_path__ + "img/logo-text-black.0488fcd0.png";